import { Icons } from '../Icons';
import type { MetricsCardProps } from '../../types';

/**
 * Composant MetricsCard pour afficher une métrique avec icône et tooltip
 * @param label - Label de la métrique
 * @param value - Valeur principale
 * @param sub - Sous-valeur optionnelle
 * @param color - Couleur du gradient ('green', 'red', 'blue', 'purple')
 * @param tooltip - Texte du tooltip optionnel
 * @param icon - Icône optionnelle
 */
export function MetricsCard({ label, value, sub, color = 'purple', tooltip, icon: Icon }: MetricsCardProps) {
  const colorClasses: Record<string, string> = {
    green: 'metric-box green',
    red: 'metric-box red',
    blue: 'metric-box blue',
    purple: 'metric-box'
  };

  return (
    <div className={colorClasses[color] || 'metric-box'} style={{ position: 'relative' }}>
      {Icon && (
        <div style={{ position: 'absolute', top: '12px', right: '12px', opacity: 0.7 }}>
          <Icon size={24} />
        </div>
      )}

      <div className="metric-label">{label}</div>
      <div className="metric-value">{value}</div>
      {sub && <div className="metric-sub">{sub}</div>}

      {tooltip && (
        <div className="tooltip-wrapper">
          <div className="tooltip-icon">
            <Icons.Info size={16} />
          </div>
          <div className="tooltip-content">{tooltip}</div>
        </div>
      )}
    </div>
  );
}
